import { SgAuxRoute, SgAuxComponentRoute, SgAuxTemplateRoute } from './models';

export function isComponentRoute<T>(route: SgAuxRoute<T>): route is SgAuxComponentRoute<T> {
  return 'component' in route;
}

export function isTemplateRoute<T>(route: SgAuxRoute<T>): route is SgAuxTemplateRoute<T> {
  return 'template' in route;
}
